"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * Converter for dark mode that runs all child elements of a node through the content transform function.
 * @param node The node containing HTML elements to convert.
 * @param skipRootElement Optional parameter to skip the root element of the Node passed in, if applicable.
 */
function convertContentToDarkMode(node, onExternalContentTransform, skipRootElement) {
    var childElements = [];
    // Get a list of all the decendents of a node.
    // querySelectorAll doesn't return a live list when called on an HTMLElement
    // So we use getElementsByTagName instead for HTMLElement types.
    if (roosterjs_editor_dom_1.isHTMLElement(node)) {
        childElements = Array.prototype.slice.call(node.getElementsByTagName('*'));
        if (!skipRootElement) {
            childElements.unshift(node);
        }
    }
    else if (roosterjs_editor_dom_1.isDocumentFragment(node)) {
        childElements = Array.prototype.slice.call(node.querySelectorAll('*'));
    }
    return childElements.length > 0
        ? function () {
            childElements.forEach(function (element) {
                if (onExternalContentTransform) {
                    onExternalContentTransform(element);
                }
                else {
                    element.style.color = null;
                    element.style.backgroundColor = null;
                }
            });
        }
        : null;
}
exports.convertContentToDarkMode = convertContentToDarkMode;
//# sourceMappingURL=convertContentToDarkMode.js.map